import { BookOpen, Eye, Play, CheckCircle, WandSparkles } from 'lucide-react';
import type { LessonTab } from './types';

export const viewStates = {
    loadingCurriculum: 0,
    curriculumReady: 1,
    addingTopics: 2,
    creatingAssessment: 4
};

export const unitsViewStates = {
    loading: 0,
    ready: 1
};

export const topicLimitDialogViewStates = {
    closed: 0,
    open: 1
};

/** Max leaf topics when creating a unit (C250 / Create Unit form). Keep in sync with atest.Constants.UnitLimits.MaxTopicsPerUnit. */
export const maxTopicsPerUnit = 10;

/** Max leaf topics selectable on Add Topics before opening the add wizard. */
export const maxTopicsPerAddToCurriculum = 1000;

export const messages = {
    pageTitle: 'Plan',
    providersFallback: 'Providers',
    studentCurriculumButton: 'Curriculum',
    breadcrumbLoading: 'Loading...',
    breadcrumbUnknownPath: 'Unknown Path',
    topicLimitTitle: 'Topic Limit Reached',
    topicLimitMessage: `A unit can include at most ${maxTopicsPerUnit} topics.`,
    topicLimitMessageAddToCurriculum: `You can select at most ${maxTopicsPerAddToCurriculum} topics at a time when adding to a student's curriculum.`,
    okButton: 'OK',
    tableHeaders: {
        lesson: 'Lesson',
        subject: 'Subject',
        progress: 'Progress',
        timeRemaining: 'Time Remaining',
        completionDate: 'Completion Date',
        minimumDuration: 'Minimum Duration',
        learningStyle: 'Learning Style',
        action: 'Action'
    },
    actionButtons: {
        startLesson: 'Start Lesson',
        continue: 'Continue',
        review: 'Review'
    },
    timeLabels: {
        hours: 'hours',
        remaining: 'remaining',
        completed: 'Completed'
    },
    emptyState: {
        title: 'No units'
    },
    validationErrors: {
        noTopicsSelected: 'Validation failed: At least one topic must be selected',
        noLearningStyle: 'Validation failed: Learning style must be selected'
    }
};

export const providers = [
    { id: 'custom', name: 'Custom curriculum' },
    { id: 'oak', name: 'National Curriculum' }
];

export const tabs = [
    {id: 'addTopics' as LessonTab, label: 'Add Topics', icon: BookOpen},
    {id: 'create' as LessonTab, label: 'Create Units', icon: WandSparkles},
    {id: 'review' as LessonTab, label: 'Approve Units', icon: Eye},
    {id: 'inprogress' as LessonTab, label: 'In Progress', icon: Play},
    {id: 'done' as LessonTab, label: 'Completed', icon: CheckCircle},
];

export const routeMap: Record<LessonTab, string> = {
    'addTopics': '/app/lessons/add-topics',
    'create': '/app/lessons/create',
    'review': '/app/lessons/review',
    'inprogress': '/app/lessons/inprogress',
    'done': '/app/lessons/completed',
    'assess': '/app/lessons/assess'
};
